export default __webpack_public_path__ + "static/media/block-slide-7.9e825bc6.jpg";